module.exports = __webpack_public_path__ + "img/supervision_320.f05e634f.png";